import * as React from "react";
import TextField from "@mui/material/TextField";
import {
  Card,
  Button,
  CardContent,
  CardHeader,
  Box,
  Alert,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

const UserLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const endpoint = "/user/login.json";
      const response = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok && data.success) {
        sessionStorage.setItem("isUser", "true");
        sessionStorage.setItem("user", JSON.stringify(data.data));
        localStorage.setItem("user", JSON.stringify(data.data));
        localStorage.setItem("authToken", "true");

        window.dispatchEvent(new Event("userLoginChange"));

        navigate("/User/DownloadUser");
      } else {
        setError(
          data.message || "Login failed. Please check your credentials.",
        );
      }
    } catch (err) {
      setError("An error occurred during login. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    sessionStorage.removeItem("isUser");
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
  }, []);

  return (
    <Box
      sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 4 }}
    >
      <Card sx={{ width: "75%", maxWidth: 500, p: 2 }}>
        <CardHeader title="Download User Login" sx={{ textAlign: "center" }} />
        <CardContent>
          <form onSubmit={handleLogin}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                disabled={loading}
                size="small"
              />

              <TextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                size="small"
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
                sx={{ mt: 2, py: 1.5 }}
              >
                {loading ? "Logging in" : "Login"}
              </Button>

              <Box sx={{ textAlign: "center", mt: 1 }}>
                <Link
                  to="/User/DownloadUser/ForgotPassword"
                  className="hyper-links"
                >
                  Forgot password?
                </Link>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

const module = {
  routeProps: {
    path: "UserLogin",
    component: UserLogin,
  },
  name: "User Login",
  label: "User Login",
  title: "User Login",
  showOnMenu: true,
};

export default module;
